// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMKanban.tsx — PropelMapper kanban board.
//
// Horizontal scroll of columns; each column has a colored header (title + count),
// is collapsible, and holds cards with an optional left status stripe. Cards
// render custom content via `renderCard(card)` or fall back to title/subtitle.
// Presentational (no drag) — wire DnD at the app layer. All --pm-* tokens.

const PMKAN_CSS = `
.pmkan{box-sizing:border-box;display:flex;gap:16px;overflow-x:auto;padding:4px 2px 12px;font-family:var(--pm-font-sans);align-items:flex-start}
.pmkan-col{box-sizing:border-box;flex:0 0 290px;background:var(--pm-surface-secondary);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);max-height:100%;display:flex;flex-direction:column}
.pmkan-col.is-collapsed{flex-basis:56px;width:56px}
.pmkan-head{display:flex;align-items:center;gap:9px;padding:13px 15px;cursor:pointer;user-select:none}
.pmkan-dot{width:10px;height:10px;border-radius:50%;flex:0 0 10px;background:var(--pm-fg-3)}
.pmkan-title{font:var(--pm-title-m);font-weight:700;color:var(--pm-fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pmkan-count{font:var(--pm-pill);background:var(--pm-surface);border:1px solid var(--pm-border);color:var(--pm-fg-2);border-radius:999px;padding:1px 8px}
.pmkan-caret{margin-left:auto;display:inline-flex;color:var(--pm-fg-3);transition:transform .15s}
.pmkan-col.is-collapsed .pmkan-caret{transform:rotate(-90deg)}
.pmkan-caret svg{width:18px;height:18px;display:block}
.pmkan-col.is-collapsed .pmkan-head{flex-direction:column;height:100%;padding:14px 0}
.pmkan-col.is-collapsed .pmkan-title{writing-mode:vertical-rl;transform:rotate(180deg);margin-top:8px}
.pmkan-col.is-collapsed .pmkan-caret{margin:0}
.pmkan-body{padding:0 11px 12px;display:flex;flex-direction:column;gap:10px;overflow-y:auto}
.pmkan-col.is-collapsed .pmkan-body,.pmkan-col.is-collapsed .pmkan-count{display:none}
.pmkan-card{position:relative;background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-l,12px);box-shadow:var(--pm-shadow-xs);padding:13px 14px 13px 16px;cursor:pointer;transition:.12s;overflow:hidden}
.pmkan-card:hover{box-shadow:var(--pm-shadow-card);border-color:var(--pm-border-dark)}
.pmkan-card::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:var(--pmkan-stripe,transparent)}
.pmkan-card-title{font:var(--pm-title-m);font-weight:600;color:var(--pm-fg-1);margin:0}
.pmkan-card-sub{font:var(--pm-body-s);color:var(--pm-fg-2);margin:4px 0 0}
.pmkan-empty{font:var(--pm-body-s);color:var(--pm-fg-3);text-align:center;padding:16px 8px}
`;
function pmkanEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmkan-css")) return;
  const s = document.createElement("style"); s.id = "pmkan-css"; s.textContent = PMKAN_CSS;
  document.head.appendChild(s);
}

export function PMKanban({
  columns = [],
  renderCard,
  onCardClick,
  maxHeight = 520,
  className = "",
  style = {},
  ...rest
}) {
  pmkanEnsureCSS();
  const [collapsed, setCollapsed] = React.useState({});
  const toggle = (id) => setCollapsed((c) => ({ ...c, [id]: !c[id] }));
  return (
    <div className={"pmkan" + (className ? " " + className : "")} style={{ maxHeight, ...style }} {...rest}>
      {columns.map((col) => {
        const isC = !!collapsed[col.id];
        const cards = col.cards || [];
        return (
          <section key={col.id} className={"pmkan-col" + (isC ? " is-collapsed" : "")}>
            <div className="pmkan-head" onClick={() => toggle(col.id)}>
              <span className="pmkan-dot" style={col.color ? { background: col.color } : undefined} />
              <span className="pmkan-title">{col.title}</span>
              <span className="pmkan-count">{cards.length}</span>
              <span className="pmkan-caret" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </span>
            </div>
            <div className="pmkan-body">
              {cards.length ? cards.map((card, i) => (
                <article key={card.id != null ? card.id : i} className="pmkan-card"
                  style={card.stripe ? { "--pmkan-stripe": card.stripe } : undefined}
                  onClick={onCardClick ? () => onCardClick(card, col) : undefined}>
                  {renderCard ? renderCard(card, col) : (
                    <React.Fragment>
                      <p className="pmkan-card-title">{card.title}</p>
                      {card.subtitle ? <p className="pmkan-card-sub">{card.subtitle}</p> : null}
                    </React.Fragment>
                  )}
                </article>
              )) : <div className="pmkan-empty">Nothing here</div>}
            </div>
          </section>
        );
      })}
    </div>
  );
}
